import React from 'react';
import './Tables.scss';
import Lottie from 'lottie-react';
import { map } from 'lodash-es';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import loader from '../../assets/lotties/loader.json';
import { useDeleteTableMutation, useGetTablesQuery } from '../../store/table/tableApi';
import { EditItem } from '../../modules/EditItem/EditItem';
import { DeleteItem } from '../../modules/DeleteItem/DeleteItem';

export const Tables = (): JSX.Element => {
	const { data: tables, isLoading: isLoadingTables } = useGetTablesQuery();
	const [deleteTable] = useDeleteTableMutation();
	const navigate = useNavigate();

	const addTableHandler = (): void => {
		navigate('/restaurantManagement/table');
	};

	const handleEditClick = (tableId: string): void => {
		navigate(`/restaurantManagement/table/${tableId}`);
	};

	const handleDeleteClick = (tableId: string): void => {
		deleteTable(tableId)
			.then(() => {
				toast.success('שולחן נמחק בהצלחה');
			})
			.catch((error) => {
				console.error('Error deleting table:', error);
				toast.error('שגיאה במחיקת שולחן');
			});
	};

	return (
		<div className="tablesContainer">
			{isLoadingTables ? (
				<Lottie animationData={loader} loop style={{ width: '10rem' }} />
			) : (
				<>
					{map(tables, (table) => (
						<div key={table.id} className="tableItem">
							<span>שם השולחן: {table.name}</span>
							<div className="tableActions">
								<EditItem onClick={(): void => handleEditClick(table.id)} />
								<DeleteItem onClick={(): void => handleDeleteClick(table.id)} />
							</div>
						</div>
					))}
					<div className="addTable" onClick={addTableHandler}>
						הוסף שולחן +
					</div>
				</>
			)}
		</div>
	);
};
